// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--c3baa";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--105bb";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--cbcce";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--947e2";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--1a3a4";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--ff423";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--d7cbe";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--76881";